module.exports = __webpack_public_path__ + "img/screwdriver.8db135b4.svg";